import { createResponsiveStateReducer } from 'redux-responsive';

import * as constants from 'common/constants';

export default createResponsiveStateReducer(
  {
    // This is a set of maximum widths
    mobile: constants.BREAKPOINT_CSS_TABLET_MIN - 1,
    tablet: constants.BREAKPOINT_CSS_DESKTOP_MIN - 1,
    desktop: constants.BREAKPOINT_CSS_WIDESCREEN_MIN - 1,
    widescreen: constants.BREAKPOINT_CSS_FULLHD_MIN - 1,
  },
  {
    infinity: 'fullhd', // A name for the width when beyond the biggest breakpoint
  }
);



// WEBPACK FOOTER //
// ./src/reducers/browser.js